import * as React from 'react'

import OptionsPopoverShell, {
  IOptionsPopoverShellProps,
} from '~/client/src/shared/components/OptionsList/shells/OptionsPopoverShell'

import { DrillDownFilterShellProvider } from './DrillDownFilterShellContext'

const DEFAULT_CONTENT_CLASS =
  'tw:w-[400px] tw:max-h-[min(560px,var(--available-height,85vh))] tw:overflow-hidden'

export interface IDrillDownFilterPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  trigger: React.ReactNode
  children: React.ReactNode
  side?: 'top' | 'bottom' | 'left' | 'right'
  align?: 'start' | 'center' | 'end'
  sideOffset?: number
  contentClassName?: string
  portalContainer?: IOptionsPopoverShellProps['portalContainer']
}

export default function DrillDownFilterPopover({
  open,
  onOpenChange,
  trigger,
  children,
  side,
  align,
  sideOffset,
  contentClassName = DEFAULT_CONTENT_CLASS,
  portalContainer,
}: IDrillDownFilterPopoverProps) {
  const shell = React.useMemo(
    () => ({ close: () => onOpenChange(false) }),
    [onOpenChange],
  )

  return (
    <DrillDownFilterShellProvider value={shell}>
      <OptionsPopoverShell
        open={open}
        onOpenChange={onOpenChange}
        trigger={trigger}
        side={side}
        align={align}
        sideOffset={sideOffset}
        contentClassName={contentClassName}
        portalContainer={portalContainer}
      >
        {children}
      </OptionsPopoverShell>
    </DrillDownFilterShellProvider>
  )
}
